<mat-drawer-container class="container" autosize>
  <mat-drawer #drawer class="sidenav" mode="over" position="end">
    <nav class="menu">
      <button mat-icon-button *ngIf="!loggedIn" (click)="onClickNav('')">
        <mat-icon>home</mat-icon>
      </button>
      <button mat-icon-button *ngIf="loggedIn" (click)="onClickNav('home')">
        <mat-icon>home</mat-icon>
      </button>
      <button mat-icon-button (click)="onClick(0)">
        <mat-icon>person</mat-icon>
      </button>
      <button mat-icon-button *ngIf="loggedIn" (click)="logOut()">
        <mat-icon>logout</mat-icon>
      </button>
      <button mat-icon-button (click)="onClickMenu(0)">
        <mat-icon>menu</mat-icon>
      </button>
    </nav>
    <div class="account" *ngIf="nav=='login'">
      {{ user.email }}
      <app-account *ngIf="loggedIn"></app-account>
      <amplify-authenticator usernameAlias="email">
        <amplify-sign-up
          slot="sign-up"
          usernameAlias="email"
          [formFields]="formFields"
        ></amplify-sign-up>
        <amplify-confirm-sign-up
          slot="confirm-sign-up"
        ></amplify-confirm-sign-up>
        <amplify-sign-in slot="sign-in" usernameAlias="email"></amplify-sign-in>
      </amplify-authenticator>
    </div>
    <div class="navSelections" *ngIf="nav=='menu'">
      <button mat-button *ngIf="loggedIn" (click)="onClickNav('settings')">Settings</button>
      <button mat-button *ngIf="user.admin" (click)="onClickNav('admin')">Admin Portal</button>
      <button mat-button (click)="onClickNav('about')">About</button>
    </div>
  </mat-drawer>
  <nav class="menu">
    <button mat-icon-button *ngIf="!loggedIn" routerLink="/">
      <mat-icon>home</mat-icon>
    </button>
    <button mat-icon-button *ngIf="loggedIn" routerLink="/home">
      <mat-icon>home</mat-icon>
    </button>
    <button mat-icon-button (click)="onClick(1)" data-test="signin">
      <mat-icon>person</mat-icon>
    </button>
    <button mat-icon-button *ngIf="loggedIn" (click)="logOut()" data-test="logout">
      <mat-icon>logout</mat-icon>
    </button>
    <button mat-icon-button (click)="onClickMenu(1)">
      <mat-icon>menu</mat-icon>
    </button>
  </nav>
  <div class="content">
    <div class="logo">
      <a class="title" *ngIf="loggedIn" routerLink="/home" routerLinkActive="active"><h1>County Land Data</h1></a>
      <a class="title" *ngIf="!loggedIn" routerLink="/"><h1>County Land Data</h1></a>
    </div>
    <br>
    <br>
    <br>
    <router-outlet></router-outlet>
  </div>
</mat-drawer-container>